<app-offers-table [locale]="locale"
                  [personId]="personId"
                  [country]="country"
                  [columns]="columnsToDisplay"
></app-offers-table>
